import * as React from 'react';

import { useMediaQuery } from '@mui/system';

import { sizes } from '@constants/sizes';

import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';

export default () => {
  const { drawerWidth } = sizes;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const isLargeScreen = useMediaQuery('(min-width: 900px)');

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  return (
    <>
      {!isLargeScreen && (
        <Navbar handleDrawerToggle={handleDrawerToggle} drawerWidth={drawerWidth} />
      )}
      <Sidebar
        handleDrawerToggle={handleDrawerToggle}
        mobileOpen={mobileOpen}
        drawerWidth={drawerWidth}
      />
    </>
  );
};
